import { ScreenSpace } from "@react-three/drei";

const CursorCollider = ({ ...props }) => {
  return (
    <ScreenSpace depth={3}>
      <mesh layers={[2]} visible={false}>
        <planeGeometry args={[10, 10]} />
        <meshStandardMaterial color="red" />
      </mesh>
    </ScreenSpace>
  );
};

export default CursorCollider;
